module.exports = __webpack_public_path__ + "img/高性能与可扩展性.6bab20e8.svg";